import React from 'react';

const valueProps = [
  {
    id: 'vp-1',
    icon: '📋',
    title: 'Upload Any Syllabus',
    desc: 'PDF, DOCX, or plain text — our AI reads it all.',
  },
  {
    id: 'vp-2',
    icon: '🗓️',
    title: 'Personalized Study Plan',
    desc: 'Day-by-day schedule built around your exam date.',
  },
  {
    id: 'vp-3',
    icon: '🧪',
    title: 'AI-Generated Practice Tests',
    desc: 'Questions crafted from your actual syllabus content.',
  },
  {
    id: 'vp-4',
    icon: '💬',
    title: 'Chat with Your Syllabus',
    desc: 'Ask anything — get instant, source-grounded answers.',
  },
];

export default function AuthBrandPanel() {
  return (
    <div
      className="hidden lg:flex lg:w-1/2 flex-col justify-between p-14 relative overflow-hidden"
      style={{ background: 'linear-gradient(145deg, #312E81 0%, #4F46E5 50%, #6D28D9 100%)' }}
    >
      {/* Background decoration */}
      <div
        className="absolute top-0 right-0 w-72 h-72 rounded-full opacity-10"
        style={{ background: 'radial-gradient(circle, #A5B4FC 0%, transparent 70%)', transform: 'translate(30%, -30%)' }}
        aria-hidden="true"
      />
      <div
        className="absolute bottom-0 left-0 w-96 h-96 rounded-full opacity-10"
        style={{ background: 'radial-gradient(circle, #C4B5FD 0%, transparent 70%)', transform: 'translate(-40%, 40%)' }}
        aria-hidden="true"
      />
      {/* Logo */}
      <div className="relative z-10">
        <div className="flex items-center gap-3 mb-16">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-white/20 backdrop-blur-sm">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-label="ExamReady book logo">
              <path d="M5 16V5a2 2 0 012-2h8a2 2 0 012 2v11l-5-2.5L5 16z" fill="white" opacity="0.95" />
              <path d="M11 3l1.8 4L17 7.5l-3 3 .7 4.2L11 12.5l-3.7 2.2.7-4.2-3-3L9.2 7z" fill="#F59E0B" opacity="0.9" />
            </svg>
          </div>
          <span className="font-bold text-2xl text-white">ExamReady</span>
        </div>

        <h1 className="text-4xl font-bold text-white leading-tight mb-4">
          Your AI-powered<br />
          <span style={{ color: '#FCD34D' }}>exam coach</span>
        </h1>
        <p className="text-lg leading-relaxed" style={{ color: 'rgba(255,255,255,0.75)' }}>
          Upload your syllabus once. Get everything you need to walk into your exam with confidence.
        </p>
      </div>
      {/* Value props */}
      <div className="relative z-10 space-y-4">
        {valueProps?.map((vp) => (
          <div
            key={vp?.id}
            className="flex items-start gap-4 p-4 rounded-xl backdrop-blur-sm"
            style={{ backgroundColor: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.15)' }}
          >
            <span className="text-2xl shrink-0">{vp?.icon}</span>
            <div>
              <p className="font-semibold text-white text-sm">{vp?.title}</p>
              <p className="text-sm mt-0.5" style={{ color: 'rgba(255,255,255,0.65)' }}>{vp?.desc}</p>
            </div>
          </div>
        ))}
      </div>
      {/* Social proof */}
      <div className="relative z-10 flex items-center gap-3 pt-4">
        <div className="flex -space-x-2">
          {['S', 'P', 'M', 'R']?.map((initial, i) => (
            <div
              key={`avatar-${initial}-${i}`}
              className="w-8 h-8 rounded-full border-2 border-white/30 flex items-center justify-center text-xs font-bold text-white"
              style={{ background: ['#6D28D9', '#0D9488', '#D97706', '#DC2626']?.[i] }}
            >
              {initial}
            </div>
          ))}
        </div>
        <p className="text-sm" style={{ color: 'rgba(255,255,255,0.7)' }}>
          <span className="font-semibold text-white">12,400+ students</span> already prepared
        </p>
      </div>
    </div>
  );
}